import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { isExternalUrl, stripDomainAndProtocalFromUrl } from "../../utilities/urlHelper";
import Sparkle from "../icons/sparkle";
 
/**
 * DonateNowButton component, specialized donation button for "Donate now" actions
 * @param {*} buttonProps
 * @returns
 */
const DonateNowButton = ({ href, text = "Donate now" }) => {
  const isExternal = isExternalUrl(href) ?? true;
  const [sanitisedHref, setSanitisedHref] = useState(href);

  useEffect(() => {
    if (!isExternal) {
      const cleanUrl = stripDomainAndProtocalFromUrl(href);
      setSanitisedHref(cleanUrl.startsWith("/") ? cleanUrl : "/" + cleanUrl);
    }
  }, [href, isExternal]);

  const starElements = (
    <>
      <Sparkle className="star-1" fillColor="#FFD700" />
      <Sparkle className="star-2" fillColor="#FFD700" />
      <Sparkle className="star-3" fillColor="#FFD700" />
      <Sparkle className="star-4" fillColor="#FFD700" />
    </>
  );

  return isExternal ? (
    <a
      href={sanitisedHref}
      className="btn-donate-now"
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
      {starElements}
    </a>
  ) : (
    <Link to={sanitisedHref} className="btn-donate-now">
      {text}
      {starElements}
    </Link>
  );
};

export default DonateNowButton;
